// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__D4I9F","currentPage":"Pagination_currentPage__RSnAV"};